export interface Tag {
  tagId: string;
  tagTypeId: string;
  tagTypeFriendlyId: string;
  tagPath: string;
  displayName: string;
  description: string;
  active: boolean | null;
  tagData?: Record<string, unknown> | null | undefined;
  createdBy: string;
}

//TO DO - Remove the CostOverride interface once its deprecated
export interface CostOverride {
  caseTypeId: string;
  serviceCosts: ServiceCost[];
}

export interface Override {
  caseTypeId: string;
  fee: number;
  active: boolean;
}

export interface ServiceCost {
  friendlyId: string;
  fee: number;
  active: boolean;
}

export interface PricingPlanOverride {
  isDefault: boolean;
  planName: string;
  serviceCosts: ServiceCost[];
  specialties: string[];
}

export interface TagFilter {
  tagFriendlyId: string;
  tagId: string;
  assignable: boolean;
  accessible: boolean;
  caseId: string;
  caseTypeFriendlyId: string;
  tagType: TagTypeFriendlyId[] | null | undefined;
}

export enum TagTypeFriendlyId {
  facility = "facility",
  hub = "hub",
  unit = "unit",
  room = "room",
  bed = "bed",
  visitType = "visit-type",
  specialty = "specialty",
  subspecialty = "subspecialty",
  qualifier = "qualifier",
  deviceType = "device-type",
  device = "device",
  cancelReason = "cancel-reason",
  consultPriority = "consult-priority",
  languages = "languages",
  templateSections = "templateSections",
  teamType = "team-type",
  serviceLocation = "service-location",
  layout = "layout",
  translationService = "translationService",
  permissions = "permissions",
  permissionsGroup = "permissions-group",
  modules = "modules",
  videoConferencingService = "video-conferencing-service"
}
